module.exports = __webpack_public_path__ + "static/media/bahia.0b69144e.svg";